export const LL_CIRCULAR_PRO = './css/ll-circular-pro.css';
export const FUTURA_PT = 'https://use.typekit.net/cqg2kpp.css';
export const CAVEAT = 'https://fonts.googleapis.com/css2?family=Caveat&display=swap';
export const FUTURABOOK = './css/futurabook.css';
export const SF_PRO_TEXT = './css/sf-pro-text.css';
export const ROBOTO_SLAB = 'https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&display=swap';
export const COURIER_PRIME = 'https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap';
